import type { CSSProperties, PropsWithChildren } from 'react';

interface IStoreBackgroundProps extends PropsWithChildren {
    backgroundImageMobile?: string;
    backgroundImageDesktop?: string;
    backgroundPosition?: string;
    backgroundPositionDesktop?: string;
    backgroundSize?: string;
    backgroundColor?: string;
    width?: string;
    height?: string;
    minHeight?: string;
    position?: CSSProperties['position'];
    overscrollBehavior?: CSSProperties['overscrollBehavior'];
}

type StoreBackgroundStyle = CSSProperties & {
    '--store-background-mobile': string;
    '--store-background-desktop': string;
    '--store-background-position-mobile': string;
    '--store-background-position-desktop': string;
};

export const StoreBackground = ({
    backgroundImageMobile,
    backgroundImageDesktop,
    backgroundPosition = 'center top',
    backgroundPositionDesktop,
    backgroundSize = 'cover',
    backgroundColor = '',
    width = '100vw',
    height = '100vh',
    minHeight = 'unset',
    position = 'static',
    overscrollBehavior,
    children,
}: IStoreBackgroundProps): React.ReactElement => {
    const style: StoreBackgroundStyle = {
        '--store-background-mobile': `url("${backgroundImageMobile ?? ''}")`,
        '--store-background-desktop': `url("${backgroundImageDesktop ?? ''}")`,
        '--store-background-position-mobile': backgroundPosition,
        '--store-background-position-desktop': backgroundPositionDesktop ?? backgroundPosition,
        backgroundColor,
        // Resolved through a custom property so the desktop media query in
        // globals.css can swap it — an inline `background-position` would
        // always beat the stylesheet rule.
        backgroundPosition:
            'var(--store-background-position-current, var(--store-background-position-mobile))',
        backgroundSize,
        width,
        height,
        minHeight,
        position,
        overscrollBehavior,
    };

    return (
        <div
            className="store-background app-store-background"
            style={style}
            data-testid="store-background"
        >
            {children}
        </div>
    );
};
